import { Next } from '@securitize/ui-components';

export const GET_ISSUER_SETTINGS_NEXT = new Next('/issuer-settings', 'GET_ISSUER_SETTINGS_NEXT');
